import { render, staticRenderFns } from "./itemTag.vue?vue&type=template&id=72cedcef&scoped=true&"
import script from "./itemTag.vue?vue&type=script&lang=js&"
export * from "./itemTag.vue?vue&type=script&lang=js&"
import style0 from "./itemTag.vue?vue&type=style&index=0&id=72cedcef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cedcef",
  null
  
)

export default component.exports